import { ExternalLink, CheckCircle2 } from "lucide-react";

export default function LicensePlate() {
  return (
    <div data-testid="license-plate-page">
      <section
        className="text-white py-20 lg:py-28"
        style={{ background: "linear-gradient(135deg, #0b6c84 0%, #1ea7c4 100%)" }}
      >
        <div className="max-w-5xl mx-auto px-6">
          <span className="inline-block text-xs font-bold tracking-[0.25em] uppercase text-[var(--rts-blue-light)] mb-4">
            Florida Approved
          </span>
          <h1 className="font-display text-3xl sm:text-5xl lg:text-6xl leading-[1.05] mb-6">
            Overdose Awareness <span className="italic">License Plate</span>
          </h1>
          <p className="text-lg text-white/85 max-w-3xl leading-relaxed">
            We're excited to announce that our Overdose Awareness license plate has been approved by the state of Florida.
          </p>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-5xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src="/license-plate.jpg"
              alt="Overdose Awareness Florida license plate"
              className="w-full rounded-2xl shadow-xl ring-1 ring-[var(--rts-blue-pale)]"
              data-testid="plate-image"
            />
          </div>
          <div className="space-y-5 text-[var(--rts-ink-soft)] leading-relaxed">
            <h2 className="font-display text-3xl sm:text-4xl text-[var(--rts-ink)]">Now the hard work starts.</h2>
            <p>
              We need to pre-sell <strong>3,000 vouchers at $33.00 each</strong>. Once we reach this goal, the state of Florida will start printing the license plates for purchase. You will be able to use the voucher to purchase your first Overdose Awareness license plate.
            </p>
            <p className="font-semibold text-[var(--rts-red)]">
              Hurry and get your voucher now! The sooner we reach our goal, the sooner we get our license plates printed.
            </p>

            <ul className="space-y-2 pt-2">
              {[
                "Approved by the State of Florida",
                "Each voucher = $33 toward our 3,000 goal",
                "Use your voucher to buy your plate once printing begins",
                "100% of awareness mission funded by these plates",
              ].map((b) => (
                <li key={b} className="flex items-start gap-2.5">
                  <CheckCircle2 className="w-5 h-5 text-[var(--rts-blue)] mt-0.5 shrink-0" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            <a
              href="https://county-taxes.net/fl-orange/vouchers"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[var(--rts-red)] hover:bg-[var(--rts-red-deep)] text-white px-7 py-3.5 rounded-full font-bold shadow-lg transition hover:-translate-y-0.5"
              data-testid="plate-voucher-cta"
            >
              Get Your Voucher <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>

      <section className="bg-[var(--rts-blue-pale)] py-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="font-display text-2xl sm:text-3xl text-[var(--rts-ink)] italic leading-snug">
            "Change the story and you change perception. Change perception and you change the world."
          </p>
          <p className="mt-4 text-xs uppercase tracking-[0.3em] font-bold text-[var(--rts-blue-deep)]">- Jean Houston</p>
        </div>
      </section>
    </div>
  );
}
